export enum FeatureKey {
  GreenId = 'greenid',
  GreenIdVerification = 'green_id_verification',
  PPSR = 'ppsr',
  Lixi = 'lixi',
  IllionConsumer = 'illion_consumer',
  IllionBroker = 'illion_broker',
  BankStatementsBroker = 'bank_statements_broker',
  Olasio = 'olasio',
  CreditSense = 'credit_sense',
  TangoLMS = 'tango_lms',
  RedBook = 'redbook',
  OcrLab = 'ocr_lab',
  EquifaxIdMatrix = 'equifax_id_matrix',
  EquifaxConsumerCreditReport = 'equifax_consumer_credit_report',
  SendConsentForm = 'send_consent_form',
  EquifaxInDepthTradingHistory = 'equifax_in_depth_trading_history',
  EquifaxCompanyTradingHistory = 'equifax_company_trading_history',
  EquifaxCompanyEnquiry = 'equifax_company_enquiry',
  EquifaxConsumerApply = 'equifax_consumer_apply',
  EquifaxPPSR = 'equifax_ppsr',
  ShowListQuickInfoTooltip = 'show_list_quick_info_tooltip',
  RegistrationButtonAndText = 'registration_button_and_text',
  SignatureEnvelopes = 'signature_envelopes',
  SendBrokerQuoteApprovalEmail = 'send_broker_quote_approval_email',
  BrokerPortalModule = 'broker_portal_module',
  ExtraFieldsForBrokerAccounts = 'extra_fields_for_broker_accounts',
  ShowDashboardInMoHeader = 'show_dashboard_in_mo_header',
  IndicativeLetterOfApproval = 'send_indicative_letter_of_approval',
  DuplicateDocument = 'duplicate_document',
  ResidentialMortgage = 'residential_mortgage',
  OrganisationsHaveRoles = 'organisations_have_roles',
  PermissionMatrix = 'permission_matrix',
  IdverseCategorizeIndividuals = 'idverse_categorize_individuals',
  ExportUsers = 'export_users',
  ExportBrokers = 'export_brokers',
  Workbooks = 'workbooks',
  ScanAttachments = 'poll_s3_attachments_schedule',
  AbortDownloadingAttachments = 'abort_downloading_unuploaded_attachments',
  DataLists = 'data_lists',
  VariableLists = 'variable_lists',
  BrokerPortalFavouriteDeals = 'broker_portal_favourite_deals',
  FraudDetection = 'fraud_detection',
  DocumentRedaction = 'document_redaction',
  SubmitCreditDecision = 'submit_credit_decision',
  AiQuickQuote = 'ai_quick_quote',
}
